import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import {
	ANALYTICS_ACTION,
	ANALYTICS_SOURCE,
	ANALYTICS_ORIGIN,
	ANALYTICS_SUBJECT,
	ANALYTICS_SUBJECT_ID,
} from '../constants/snippetAnalytics.ts';
import { SnippetScope } from '../snippetTypes.ts';

export enum SnippetModalEvents {
	CANCELLED = 'snippetEditorModalCancelled',
	CLOSED = 'snippetEditorModalClosed',
	CREATED = 'snippetEditorModalCreated',
	DUPLICATED = 'snippetEditorModalDuplicated',
	EDITED = 'snippetEditorModalEdited',
}

const baseAnalyticsData = {
	source: ANALYTICS_SOURCE,
	actionSubject: ANALYTICS_SUBJECT.BUTTON,
	action: ANALYTICS_ACTION.CLOSED,
	actionSubjectId: ANALYTICS_SUBJECT_ID.CREATE_SNIPPET,
	type: 'ui' as const,
};

/**
 * Returns handleClose(event) that fires analytics and calls onClose.
 * Use in Create/Edit/Duplicate modals for consistent close analytics.
 */
export function useSnippetModalClose(onClose: () => void): (event: SnippetModalEvents) => void {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { userId, cloudId } = useSessionData();

	const baseAnalyticsAttributes = {
		origin: ANALYTICS_ORIGIN.SNIPPET_EDITOR_MODAL,
		...(userId != null && { userId }),
		...(cloudId != null && { cloudId }),
		scope: SnippetScope.USER,
	};

	return (event: SnippetModalEvents) => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				...baseAnalyticsData,
				attributes: { ...baseAnalyticsAttributes, event },
			},
		}).fire();
		onClose();
	};
}
